/**
 * formatErrorMessage('${name} is a required field', {name: 'email'});
 * output: 'email is a required field'
 */
export default function formatErrorMessage(errorMessage, params) {
  if (typeof errorMessage === 'string') {
    return errorMessage.replace(/\$\{\s*(\w+)\s*\}/g, function (_, key) {
      return (params === null || params === void 0 ? void 0 : params[key]) || "[" + key + "]";
    });
  }

  return errorMessage;
}